import type { Checkbox as CheckboxPrimitive } from "radix-ui";

import { Checkbox as CrowCheckbox } from "@crow/ui/checkbox";
import { cn } from "../../lib/utils";

/**
 * The design system's checkbox (`design-system/ui`, copied in `src/crow`), with Radix's
 * `checked` (`'indeterminate'` shows a dash). Name it with a `<label htmlFor={id}>` or `aria-label`.
 */
function Checkbox({
	checked,
	onCheckedChange,
	className,
	...props
}: {
	checked?: CheckboxPrimitive.CheckedState;
	defaultChecked?: boolean;
	onCheckedChange?: (checked: boolean) => void;
	id?: string;
	name?: string;
	disabled?: boolean;
	className?: string;
	"aria-label"?: string;
}) {
	return (
		<CrowCheckbox
			{...props}
			checked={checked === "indeterminate" ? undefined : checked}
			indeterminate={checked === "indeterminate"}
			onCheckedChange={onCheckedChange}
			className={cn("peer", className)}
		/>
	);
}

export { Checkbox };
